export default __webpack_public_path__ + "9e563f34ae16bfdea1f07cfcd36e9ba3.png";